// RebrandPage.js
import React from 'react';
import { Helmet } from "react-helmet";
import { websiteName } from '../../utils/environment';

// The site has rebranded from Flowster to Meeako and lives on a new domain.
// This page is served from the old domain to explain the move. It never
// redirects on its own -- visitors click through when they are ready.
const NEW_SITE_URL = 'https://www.meeako.com';
const OLD_BRAND_NAME = 'Flowster';

const RebrandPage = () => {

    return (
        <>
            <Helmet>
                <title>{"We've moved to Meeako.com | " + websiteName}</title>
                <meta
                    name="description"
                    content={OLD_BRAND_NAME + " is now " + websiteName + ", a product coach trained on real products. Visit us at meeako.com."}
                />
            </Helmet>

            <div
                className="rebrand-page"
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    padding: "50px 0"
                }}
            >
                <div
                    className="ui text container"
                    style={{ textAlign: "center" }}
                >
                    <img
                        className="ui centered image"
                        src="/assests/meeako.svg"
                        alt={websiteName}
                        style={{ width: "110px", height: "auto", marginBottom: "1.5em" }}
                    />

                    <h1 className="ui header" style={{ fontSize: "3em", marginTop: "0em" }}>
                        {OLD_BRAND_NAME} is now {websiteName}
                    </h1>

                    <h2
                        className="ui header"
                        style={{ fontSize: "1.5em", marginTop: "0.25em", color: "#888", fontWeight: "normal" }}
                    >
                        A new name, a new home, and a product coach at meeako.com
                    </h2>

                    <p style={{ marginTop: "2em" }}>
                        We've rebranded, and the product has grown into something bigger.
                        {" "}<strong>meeako.com</strong> is now a product coach trained on
                        real products, there to help you think through how great products
                        grow, monetize, and retain.
                    </p>

                    <p>
                        The app research you came here for still underpins it &mdash; those
                        apps and their flows are what inform the coach, and you can browse
                        them on the new site. This address won't be updated any further, so
                        head over and update any bookmarks you have saved.
                    </p>

                    <a
                        className="ui icon secondary circular button right labeled icon"
                        href={NEW_SITE_URL}
                        style={{ marginTop: "1.5em" }}
                    >
                        <i className="arrow right icon"></i>
                        Go to {websiteName}
                    </a>

                    <p style={{ marginTop: "2.5em", color: "#888" }}>
                        Questions about the move? Email us at{" "}
                        <a href="mailto:info@meeako.com?subject=Question%20about%20the%20move%20to%20Meeako">
                            info@meeako.com
                        </a>
                        .
                    </p>
                </div>
            </div>
        </>
    );
};


export default RebrandPage
